import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { ASYNC_MENU_LOAD_DATA } from 'store';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartBar, faLaptop, faFileAlt, faHouseUser, faUser, faMoneyBill, faBuilding, faBullhorn, faBars, faChartArea, faBook, faDotCircle } from '@fortawesome/free-solid-svg-icons'
import { MenuItem, ProSidebar, SidebarContent, SidebarHeader, Menu } from 'react-pro-sidebar';
import { a } from 'react-router-dom';
import { AssignmentIndOutlined, BusinessOutlined, ContactsOutlined, DescriptionOutlined, GroupAddOutlined, HelpOutline, ListAltOutlined, RecordVoiceOverOutlined } from '@material-ui/icons';
import *  as logoLight from "../../images/logo-light.png"
import *  as logoSm from "../../images/logo-sm.png"
import 'react-pro-sidebar/dist/css/styles.css';
import LoginService from 'services/login';
const MenuT = ({ className, loadMenu, menu, collapsed, setCollapsed }) => {

  let isMobile = false;
  return (<>
    <FontAwesomeIcon className={"menu-icon ml-2 mr-2"+(!!collapsed?' collapsed':'')} icon={faBars} onClick={() => setCollapsed(!collapsed)} />
    <ProSidebar
          collapsed={collapsed}
          className="menu-lateral shadow">
          <SidebarHeader>
            <a href="#" className="logo text-center">
              {collapsed?
              <span className="logo-sm">
                <img src={logoSm} alt="" height="24" />
              </span>
              :
              <span className="logo-lg">
                  <img src={logoLight} alt="" height="38" />
              </span>
              }
            </a>
          </SidebarHeader>
          <SidebarContent className="mt-5">
            <Menu iconShape="square">
              <MenuItem icon={<FontAwesomeIcon icon={faChartBar} className="icon-menu" />} 
              active={true}>
                <a target="_self" href="/sumo/quote-request">
                  <span className="ml-2">Dashboard</span>
                </a>
              </MenuItem>
              <MenuItem icon={<FontAwesomeIcon icon={faLaptop} className="icon-menu" />} 
              active={true}>
                <a target="_self" href="https://elite.scansource.com/login" onClick={async(e)=>{
                  e.preventDefault();
                  let link = e.target.href;
                  let response = await LoginService.generateAutoLoginToken();
                  let token = response.data;
                  let newlink = document.createElement('a');
                  newlink.setAttribute('target', '_blank');
                  newlink.setAttribute('href', link+"?t-al="+token);
                  newlink.click();
                }}>
                  <span className="ml-2">Elite</span>
                </a>
              </MenuItem>
              <MenuItem icon={<FontAwesomeIcon icon={faBuilding} className="icon-menu" />} 
              active={true}>
                <a target="_self" href="/sumo/resales">
                  <span className="ml-2">Revendas</span>
                </a>
              </MenuItem>
              <MenuItem icon={<FontAwesomeIcon icon={faBullhorn} className="icon-menu" />} 
              active={true}>
                <a target="_self" href="/sumo/campaigns">
                  <span className="ml-2">Campanhas</span>
                </a>
              </MenuItem>
              <MenuItem icon={<FontAwesomeIcon icon={faFileAlt} className="icon-menu" />} 
              active={true}>
                <a target="_self" href="/sumo/resales/show">
                  <span className="ml-2">Dados da Revenda</span>
                </a>
              </MenuItem>
              <MenuItem icon={<FontAwesomeIcon icon={faHouseUser} className="icon-menu" />} 
              active={true}>
                <a target="_self" href="/sumo/resales/attendance">
                  <span className="ml-2">Atendimento</span>
                </a>
              </MenuItem>
              <MenuItem icon={<FontAwesomeIcon icon={faMoneyBill} className="icon-menu" />} 
              active={true}>
                <a target="_self" href="/sumo/resales/brands">
                  <span className="ml-2">Marcas</span>
                </a>
              </MenuItem>
              <MenuItem icon={<FontAwesomeIcon icon={faUser} className="icon-menu" />} 
              active={true}>
                <a target="_self" href="/sumo/resales/lead-history">
                  <span className="ml-2">Histórico de Leads</span>
                </a>
              </MenuItem>
              <MenuItem icon={<FontAwesomeIcon icon={faChartArea} className="icon-menu" />} 
              active={true}>
                <a target="_self" href="/sumo/charts">
                  <span className="ml-2">Gráfico de Leads</span>
                </a>
              </MenuItem>
              <MenuItem icon={<FontAwesomeIcon icon={faDotCircle} className="icon-menu" />} 
              active={true}>
                <a target="_self" href="/sumo/leads-controller">
                  <span className="ml-2">Controle de Leads</span>
                </a>
              </MenuItem>
              <MenuItem icon={<FontAwesomeIcon icon={faBook} className="icon-menu" />} active={true}>
                <a target="_self" href="/sumo/report-leads-by-status">
                  <span className="ml-2">Relatório de Leads</span>
                </a>
              </MenuItem>
              <MenuItem icon={<FontAwesomeIcon icon={faBook} className="icon-menu" />} active={true}>
                <a target="_self" href="/sumo/report-leads-error">
                  <span className="ml-2">Relatório de Erros</span>
                </a>
              </MenuItem>
              {/* 
              <Can do="profile.index" on="App">
                <MenuItem icon={<AssignmentIndOutlined className="icon-menu" />}><a href="/profiles" onClick={()=>isMobile ? props.setCollapsed(true) : props.setCollapsed(props.collapsed)}>Perfis</a></MenuItem>
              </Can> 
              */}
            </Menu>

          </SidebarContent>
        </ProSidebar>

  </>);


};

const mapStateToProps = (state) => ({
  menu: state.menu,
});

const mapDispatchToProps = (dispatch) => ({
  loadMenu: () => dispatch({ type: ASYNC_MENU_LOAD_DATA }),
});

export default connect(mapStateToProps, mapDispatchToProps)(MenuT);
